import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { APP, BASE, HOME } from '../captivision.config';
import { CVEnglishOnly, CVFavicon, CVTopbar, CVFooter, contentLanguage, useCaptiVisionTheme } from '../shell.component';
import { localizedPage, useLocalizedPage } from '../i18n/localized-page';

import english from './locales/story.en';

import '../captivision.styles.scss';

// How CaptiVision started: a classroom at UT Austin during the Mandela
// Washington Fellowship. A long read with photo rows between the paragraphs,
// written out once per language in locales/.

const PAGES = localizedPage(english, code => import(/* webpackChunkName: "[request]" */ `./locales/story.${code}`));

const CaptiVisionStory = () => {
    const [theme, toggleTheme] = useCaptiVisionTheme();
    const [page, lang] = useLocalizedPage(PAGES);
    const title = page?.title;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        document.title = title || APP.name

        return () => { document.title = APP.name }
    }, [title])

    return (
        <div className="captivision cv-story-page">
            <CVFavicon />
            <CVTopbar theme={theme} onToggleTheme={toggleTheme} current="Story" />
            <CVEnglishOnly lang={lang} />

            {page ? (
                <main {...contentLanguage(lang)}>
                    <header className="cv-story-head">
                        <span className="cv-eyebrow"> {page.eyebrow} </span>
                        <h1> {page.title} </h1>
                        <p className="cv-lede"> {page.lede} </p>
                    </header>

                    <article className="cv-story">
                        {page.body}
                    </article>

                    <section className="cv-page cv-closing">
                        <h2> {page.closing.title} </h2>
                        <div className="cv-hero-actions">
                            <Link className="cv-btn cv-btn-accent" to={`${HOME}#how`}> {page.closing.how} </Link>
                            <Link className="cv-btn" to={`${BASE}/get-started`}> {page.closing.start} </Link>
                        </div>
                    </section>
                </main>
            ) : <main />}

            <CVFooter current="Our story" />
        </div>
    )
}

export default CaptiVisionStory;
